"use client";

import {Transition} from "./Transition";

interface LoadingOverlayProps {
  isLoading: boolean;
  withTexts?: boolean;
  text?: string;
}

function LoadingDots({text}: {text: string}) {
  return (
    <div className="text-foreground mt-4 text-center text-xs">
      {text}
      <span className="dot">.</span>
      <span className="dot">.</span>
      <span className="dot">.</span>
    </div>
  );
}

function LoadingOverlay({
  isLoading,
  withTexts = true,
  text = "Loading",
}: LoadingOverlayProps) {
  if (!isLoading) return null;

  return (
    <Transition>
      <div className="bg-background fixed inset-0 z-50 flex items-center justify-center">
        <div className="flex flex-col items-center justify-center">
          <svg
            viewBox="0 0 36 36"
            width="36"
            height="36"
            className="loader bg-loader-foreground"
          >
            <path
              fill="var(--foreground)"
              d="M33.8 16h-8.2l7.1-4.1c.9-.5 1.4-1.7.9-2.7s-1.8-1.5-2.8-.9l-7.2 4.1 4.1-7.1c.5-.9.4-2.2-.5-2.8s-2.3-.4-2.9.6l-4.1 7.2V2.2c0-1.1-.8-2.1-1.8-2.2s-2.2.8-2.2 2v8.3l-4.1-7.1c-.5-.9-1.7-1.4-2.7-.9s-1.5 1.8-.9 2.8l4.1 7.2-7.1-4.1c-.9-.5-2.2-.4-2.8.5s-.4 2.3.6 2.9l7.2 4.1H2.2c-1.1 0-2.1.8-2.2 1.8s.8 2.2 2 2.2h8.3l-7.1 4.1c-.9.5-1.4 1.7-.9 2.7s1.8 1.5 2.8.9l7.2-4.1-4.1 7.1c-.5.9-.4 2.2.5 2.8s2.3.4 2.9-.6l4.1-7.2v8.2c0 1.1.8 2.1 1.8 2.2s2.2-.8 2.2-2v-8.3l4.1 7.1c.5.9 1.7 1.4 2.7.9s1.5-1.8.9-2.8l-4.1-7.2 7.1 4.1c.9.5 2.2.4 2.8-.5s.4-2.3-.6-2.9l-7.2-4.1h8.3c1.2 0 2.1-1 2-2.2s-1.1-1.8-2.2-1.8Z"
            />
          </svg>
          {withTexts && <LoadingDots text={text} />}
        </div>
      </div>
    </Transition>
  );
}

export {LoadingOverlay};
